import React from 'react'
import Hero from '../components/hero'
import Navigation from '../components/navbar'

export default function Homepage(){
    return(
        <>
        <Navigation/>
        <Hero/>
        
        
        </>
    )
}